/**
 * Welcome overlay versions (append to any page URL):
 *   &wel-version=talent
 *   &wel-version=cannes
 *   
 *   &wel-version=test
 * 
 *  example full url: www.philantropica.club/?pw=deutsche-bank&wel-version=test
 */
(function () {
  // Set to true during testing to always show the overlay.
  var FORCE_SHOW_FOR_TESTING = false;
  var DISMISSED_KEY = 'siteWelcomeOverlayDismissed';
  var DISMISSED_CLASS = 'site-welcome-overlay__dismissed';
  var VERSION_PARAM = 'wel-version';

  var WELCOME_CONTENT = {
    talent: {
      paragraph:
        'Welcome to the Philantropica Club.\n\n' +
        'Philantropica is a soft drink so rare it makes Hermès look like fast fashion, and Dom Pérignon taste like office water.\n' +
        "It's not just a drink. It's a declaration.\n" +
        'Of taste. Of status. Of effortless benevolence.\n\n' +
        "Together we will fund the largest ocean cleanup in history. This is a club committed to change - we're honored to have you here.",
      button: 'Enter Your Philantropica Universe',
    },
    cannes: {
      paragraph:
        'As you witnessed today, Philantropica is a soft drink so rare it makes Hermès look like fast fashion, and Dom Pérignon taste like office water.\n' +
        "It's not just a drink. It's a declaration.\n" +
        'Of taste. Of status. Of effortless benevolence.\n' +
        'Together we will fund the largest ocean cleanup in history. A club committed to change and to sailing to even higher heights.',
      button: 'Enter the digital Philantropica universe',
    },
    test: {
      paragraph:
        'this is a test.\n' +
        'two.\n' +
        'line three here.\n',
      button: 'example button',
    },
    oceans: {
      paragraph:
        'In honour of World Ocean Day, we are inviting you to join Philantropica Club.\n\n' +
        "Philantropica is a drink so rare and so impactful, it makes Hermès look like fast fashion, and Dom Pérignon taste like office water.\n\n" + 
        "It's a declaration. Of taste. Of status. Of effortless generosity.\n\n" +
        "Philantropica is a call to redirect consumerism and a club committed to change - we're honored to have you here.",
      button: 'Enter the Philantropica Universe',
    },
    goals: {
      paragraph:  
       'Welcome to your private Goals House access to Philantropica.\n\n' +
        "A drink so rare and so impactful, it makes Hermès look like fast fashion, and Dom Pérignon taste like office water.\n\n" + 
        "It's not just a drink. It's a declaration. Of taste. Of status Of effortless benevolence.\n\n" +
        "Together we will fund the largest ocean health campaign in history. This is a club committed to change - we're honored to have you here.",
      button: 'Enter the Philantropica Universe',
    },
    deutsche: {
      paragraph:  
       'Welcome to your private Deutsche Bank access to Philantropica.\n\n' +
        "A soft drink so rare and so impactful it makes Hermès look like fast fashion, and Dom Pérignon taste like office water.\n\n" + 
        "It's not just a drink. It's a declaration. Of taste. Of status Of effortless generosity.\n\n" +
        "This is a club committed to change - we're honored to have you here.",
      button: 'Enter the Philantropica Universe',
  },
  welcome: {
      paragraph:  
       'This is your private access to Philantropica.\n\n' +
        "A soft drink so rare and so impactful it makes Hermès look like fast fashion, and Dom Pérignon taste like office water.\n\n" + 
        "It's not just a drink. It's a declaration. Of taste. Of status. Of effortless generosity.\n\n" +
        "This is a club committed to change - we're honored to have you here.",
      button: 'Enter the Philantropica Universe',
  },
   general: {
      paragraph:  
       'This is your private access to Philantropica.\n\n' +
        "A soft drink so rare and so impactful it makes Hermès look like fast fashion, and Dom Pérignon taste like office water.\n\n" + 
        "It's not just a drink. It's a declaration. Of taste. Of status. Of effortless generosity.\n\n" +
        "This is a club committed to change - we're honored to have you here.",
      button: 'Enter the Philantropica Universe',
  },
   Launch: {
      paragraph:  
        "Philantropica is a soft drink so rare and so impactful it makes Hermès look like fast fashion, and Dom Pérignon taste like office water.\n\n" + 
        "It's not just a drink. It's a declaration. Of taste. Of status. Of effortless generosity.\n\n" +
        "This is a club committed to change - we're honored to have you here.",
      button: 'Enter the Philantropica Universe',
  }
    }

  var root = document.getElementById('SiteWelcomeOverlay');

  function getUrlParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (error) {
      return null;
    }
  }

  function getWelcomeVersion() {
    var param = getUrlParam(VERSION_PARAM);
    if (param && WELCOME_CONTENT[param]) {
      return param;
    }
    return null;
  }

  function setParagraphContent(container, text) {
    if (!container) {
      return;
    }

    var parts = text.split(/\n\n+/).map(function (part) {
      return part.trim();
    }).filter(Boolean);

    if (parts.length === 0) {
      parts = [text.trim()];
    } else if (parts.length === 1 && parts[0].indexOf('\n') !== -1) {
      parts = parts[0].split('\n').map(function (line) {
        return line.trim();
      }).filter(Boolean);
    }

    container.innerHTML = '';
    parts.forEach(function (part) {
      var paragraph = document.createElement('p');
      paragraph.textContent = part;
      container.appendChild(paragraph);
    });
  }

  function applyWelcomeContent() {
    if (!root) {
      return;
    }

    var version = getWelcomeVersion();
    if (!version) {
      return;
    }

    var content = WELCOME_CONTENT[version];
    var paragraphEl = root.querySelector('.site-welcome-overlay__paragraph');
    var buttonEl = root.querySelector('.site-welcome-overlay__button');

    setParagraphContent(paragraphEl, content.paragraph);

    if (buttonEl) {
      buttonEl.textContent = content.button;
    }
  }

  var savedScrollY = 0;

  function setPageScrollLock(locked) {
    var docEl = document.documentElement;
    var body = document.body;

    if (locked) {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      docEl.style.overflowY = 'hidden';
      body.style.position = 'fixed';
      body.style.top = '-' + savedScrollY + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      return;
    }

    docEl.style.overflowY = '';
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';

    // Entry experience should always land at the top of the page.
    window.scrollTo(0, 0);
  }

  function setHiddenState(hidden) {
    if (!root) {
      return;
    }

    root.classList.toggle('is-hidden', hidden);
    if (!hidden) {
      root.removeAttribute('data-is-dismissing');
    }
    root.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    setPageScrollLock(!hidden);
  }

  function hasBeenDismissed() {
    try {
      return window.localStorage.getItem(DISMISSED_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  function markDismissed() {
    try {
      window.localStorage.setItem(DISMISSED_KEY, 'true');
      window.dispatchEvent(
        new CustomEvent('siteWelcomeOverlayDismissedChange', {
          detail: { dismissed: true },
        })
      );
    } catch (error) {
      // Ignore storage issues and continue with UI state.
    }

    document.documentElement.classList.add(DISMISSED_CLASS);
  }

  function clearDismissed() {
    try {
      window.localStorage.removeItem(DISMISSED_KEY);
    } catch (error) {
      // Ignore storage issues and continue with UI state.
    }

    document.documentElement.classList.remove(DISMISSED_CLASS);
  }

  function hideSiteWelcomeOverlay() {
    root.setAttribute('data-is-dismissing', 'true');
    markDismissed();
    setHiddenState(true);
  }

  function showSiteWelcomeOverlay() {
    clearDismissed();
    setHiddenState(false);
  }

  window.hideSiteWelcomeOverlay = hideSiteWelcomeOverlay;
  window.showSiteWelcomeOverlay = showSiteWelcomeOverlay;

  if (!root) {
    return;
  }

  applyWelcomeContent();

  var backdrop = root.querySelector('[data-site-welcome-overlay-backdrop]');
  var closeButton = root.querySelector('[data-site-welcome-overlay-close]');

  if (backdrop) {
    backdrop.addEventListener('click', hideSiteWelcomeOverlay);
  }

  if (closeButton) {
    closeButton.addEventListener('click', hideSiteWelcomeOverlay);
  }

  if (FORCE_SHOW_FOR_TESTING) {
    clearDismissed();
    setHiddenState(false);
    return;
  }

  if (hasBeenDismissed()) {
    document.documentElement.classList.add(DISMISSED_CLASS);
    setHiddenState(true);
    return;
  }

  setHiddenState(false);
})();
